import { I18n } from '@app/i18n/strings-keys';
import { IPdfSignature } from '@app/shared/common/make-pdf/v2';

const DEFAULT_SIGNATURE_LINE_STYLE: IPdfSignature = {
  width: '*',
  fontSize: 9,
  alignment: 'right',
  text: '',
};

export const TRANSFER_DEFAULT_SIGNATURE_LINES_COLUMN: IPdfSignature[][] = [
  [
    {
      ...DEFAULT_SIGNATURE_LINE_STYLE,
      text: I18n.Common.PulledBy,
      margin: [0, 15, 3, 0],
      withoutSignatureLine: true,
      width: '15%',
    },
    {
      ...DEFAULT_SIGNATURE_LINE_STYLE,
      alignment: 'left',
    },
    {
      ...DEFAULT_SIGNATURE_LINE_STYLE,
      text: I18n.Common.Signature,
      alignment: 'left',
    },
  ],
  [
    {
      ...DEFAULT_SIGNATURE_LINE_STYLE,
      text: I18n.Forms.GridForm.DeliveredByInSignature,
      margin: [0, 15, 3, 0],
      withoutSignatureLine: true,
      width: '15%',
    },
    {
      ...DEFAULT_SIGNATURE_LINE_STYLE,
      alignment: 'left',
    },
    {
      ...DEFAULT_SIGNATURE_LINE_STYLE,
      text: I18n.Common.Signature,
      alignment: 'left',
    },
  ],
  [
    {
      ...DEFAULT_SIGNATURE_LINE_STYLE,
      text: I18n.Forms.GridForm.ReceivedByInSignature,
      margin: [0, 15, 3, 0],
      withoutSignatureLine: true,
      width: '15%',
    },
    {
      ...DEFAULT_SIGNATURE_LINE_STYLE,
      alignment: 'left',
    },
    {
      ...DEFAULT_SIGNATURE_LINE_STYLE,
      text: I18n.Common.Signature,
      alignment: 'left',
    },
  ],
];
